import PointerControl from '../views/dragview/PointerControl';


export default class SwipeControl extends PointerControl {

	static defaultProps = {
		onSwipeLeft 	: null,
		onSwipeRight	: null,
		onSwipeUp		: null,
		onSwipeDown		: null,
		onSwipe			: null,		//swipe event for all directions
		onRelease		: null,		//no swiping

		dragLimit		: 20,		//dont take drag events smaller than 20 pixel
		timeLimit		: 500,		//minimal drag time
		speedLimit		: 0.2,		//minimal number of draged pixels per millisecond
	}


	constructor(target, props){
		var pnew = {...SwipeControl.defaultProps, ...props};			//copy defaultProps

		super(target, pnew);

		this.direction = 'none';

		let p = this.props;
		this.fnc = {
			'left'	: p.onSwipeLeft,
			'right' : p.onSwipeRight,
			'up'	: p.onSwipeUp,
			'down'	: p.onSwipeDown,
		}
	}


	onDragStart(){
		super.onDragStart();

		this.startTime = performance.now();
		this.direction = 'none';
	}


	onDragStop(e){
		super.onDragStop(e);

		let p = this.props;
		let time = performance.now() - this.startTime;

		let x = this.drag.x, y = this.drag.y;
		let xa = Math.abs(x), ya = Math.abs(y);

		if (time > p.timeLimit || Math.max(xa, ya) / time < p.speedLimit){
			p.onRelease?.(this)
			return;		//limit reached
		}

		this.direction = xa >= ya? (x < 0? 'left' : 'right') : (y < 0? 'up' : 'down');

		p.onSwipe?.(this.direction, xa, ya);
		if (this.fnc[this.direction]) this.fnc[this.direction](xa, ya);
	}
}
